import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=0ee302a5&scoped=true"
var script = {}
import style0 from "./MyFooter.vue?vue&type=style&index=0&id=0ee302a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee302a5",
  null
  
)

export default component.exports